import { Column } from 'react-table'
import { columnGenerators } from '../../../../../../_metronic/helpers'

const header = [
  {
    label: 'S.N',
    value: 'id',
  },
  {
    label: 'Name',
    value: 'name',
  },
  {
    label: 'Display name',
    value: 'displayName',
  },
  {
    label: 'Icon',
    value: 'avatar',
  },
  {
    label: 'Grade',
    value: 'gradeId',
  },
  {
    label: 'Color',
    value: 'colorId',
  },
  {
    label: 'Part number',
    value: 'erpCode',
  },
  {
    label: 'BOM',
    value: 'bom',
  },
  {
    label: 'QC test',
    value: 'test',
  },
  {
    action: ['edit', 'toggle'],
  },
]

const roleColumns: ReadonlyArray<Column<any>> = columnGenerators(header)

export { roleColumns }